import React from "react";
import { graphql, Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Layout from "../components/layout"
import Seo from "../components/seo"

const title = "Virtual Market 3 \"NEO SHIBUYA\""
const scope = "VR空間体験設計・制作"
const str1 = "「バーチャルマーケット3」の会場「ネオ渋谷」の空間体験ディレクション、制作チームの一員として主要部の制作を行った。"
const str2 = "渋谷を渋谷たらしめている要素を抽出し再構成するとともに、ハチ公像や青蛙やひばり号といった渋谷の過去・現在を彩るランドマーク・交通に新たに命を吹き込むことで、低負荷かつ祝祭的な都市の姿を実現している。"

const settings = {
  arrows: false,
  fade: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  speed: 1000,
  autoplaySpeed: 5000,
  pauseOnHover: false,
}

export default ({ data, location }) => (
      <Layout>
        <Seo
          pagetitle={title}
          pagedesc={str1}
          pagepath={location.pathname}
          pageimg={data.neo01.childImageSharp.original.src}
          pageimgw={data.neo01.childImageSharp.original.width}
          pageimgh={data.neo01.childImageSharp.original.height}
        />
        <div className="nav">
          <Link to = {`/works/`}>
            <svg className="switchButton" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 99.41 52.83">
            <g id="_レイヤー_2" data-name="レイヤー_2">
              <g id="UI">
                <path d="M1.4,2.2l47.3,24.2L1.4,50.7l.4.9,47.9-24.6,47.9,24.6.5-.9-47.3-24.3L98,2.1l-.5-.9-47.8,24.6L1.8,1.2l-.4.9Z"/>
              </g>
            </g>
            </svg>
          </Link>
        </div>
        <div id="pageBody" className="wrapper">
          <Slider {...settings}>
            <div className="full">
              <StaticImage className="cover" src="../images/neo01.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/neo02.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/neo03.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/neo04.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/neo05.jpg" alt="" />
            </div>
          </Slider>
          <div className="title">
            <h4>{title}</h4>
            <p><span>{scope}</span></p>
            <br />
            <p>{str1}</p>
            <p>{str2}</p>
          </div>
        </div>
      </Layout>
)

export const query = graphql`
query {
  neo01: file(relativePath: {eq: "neo01.jpg"}) {
    childImageSharp {
      original {
        height
        src
        width
      }
    }
  }
}
`
